import React from 'react';
import { Tag, Typography } from '@guildeducationinc/recess';
import CloseIcon from '@guildeducationinc/recess/icons/CloseIcon';
import classnames from 'classnames';
import styles from './InputTag.module.scss';

interface InputTagProps {
	/**
	 * What to do when the tag is clicked on (eg: update state to remove the tag)
	 */
	onClick?: () => void;
	/**
	 * The content to render within the tag.
	 */
	children?: React.ReactNode;

	/*
	 * The data test id to use for the tag
	 */
	testId?: string;

	/**
	 * Whether or not we show the close icon
	 */
	showCloseIcon?: boolean;
}

export const InputTag: React.FC<InputTagProps> = ({
	onClick,
	children,
	testId,
	showCloseIcon = true,
}) => {
	return (
		<div
			className={styles.tagWrapper}
			data-testid={testId}
			onClick={() => {
				if (!onClick) return;
				onClick();
			}}
			onKeyDown={e => {
				if (!onClick) return;
				if (e.key === 'Enter') {
					onClick();
				}
			}}
			role={onClick ? 'button' : null}
			tabIndex={onClick ? 0 : null}
		>
			<Tag
				appearance='outline'
				className={classnames(styles.tag, { [styles.clickable]: !!onClick })}
				color='grey'
			>
				{onClick ? <Typography variant='body1'>{children}</Typography> : <span>{children}</span>}
				{showCloseIcon && <CloseIcon className='margin--left_4' size={16} />}
			</Tag>
		</div>
	);
};
